import AdvisorAvatar from './AdvisorAvatar';

export default AdvisorAvatar;
